import { can } from '@/utils/permissions';

export const permisionsMixin = {
  methods: {
    can: can
  }
};
